var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgGreenStar = function SvgGreenStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_green_star_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9079 33.5416C74.951 32.332 74.0453 31.331 72.8377 31.1642L54.5944 28.62C53.8181 28.4948 53.128 28.036 52.783 27.327L44.6317 11.3109C44.0279 10.143 42.6047 9.68423 41.3971 10.2264C40.9227 10.435 40.5345 10.8104 40.2758 11.3109L32.1245 27.2853C31.7795 27.9943 31.0894 28.4531 30.3131 28.5783L12.1129 31.1225C10.9053 31.2893 9.99959 32.332 10.0427 33.4999V38.2964C9.99959 38.9637 10.2584 39.6311 10.7759 40.0898L23.9732 52.519C24.0163 52.5607 24.0595 52.6025 24.1026 52.6859L21.5149 67.2005C21.3855 67.9512 21.4718 72.8729 21.5149 72.9146C21.558 73.1231 21.6011 73.3317 21.6874 73.5402C21.6874 73.5819 21.7305 73.6236 21.7737 73.707C21.903 73.9573 22.0756 74.1658 22.2481 74.3327C22.3775 74.4578 22.5068 74.5412 22.6362 74.6246C23.0244 74.8332 23.4557 75 23.887 75C24.0163 75 24.1457 75 24.232 75C24.3614 74.9583 24.5339 74.9583 24.6633 74.9166L24.7926 74.8749L24.9652 74.7915L25.0514 74.7497L41.354 66.4497C42.044 66.0743 42.9066 66.0743 43.5967 66.4497L59.8992 74.708L59.9855 74.7497C60.2442 74.8749 60.503 74.9166 60.7618 74.9583C60.8912 74.9583 60.9774 74.9583 61.1068 74.9583C61.2362 74.9583 61.3224 74.9583 61.4518 74.9166C62.4438 74.7498 63.2632 73.999 63.4357 73.0397C63.4789 72.9146 63.4789 72.8312 63.4789 72.706C63.4789 72.5809 63.5651 67.9095 63.4357 67.1588L60.8912 52.6859C60.9343 52.6442 60.9774 52.5607 61.0637 52.519L74.261 40.0898C74.7785 39.6311 75.0373 38.9637 74.9942 38.2964L74.9079 33.5416Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6325 11.3102L52.7838 27.2846C53.1288 27.9936 53.8189 28.4524 54.5952 28.5776L72.8385 31.1218C74.1755 31.3303 75.0812 32.4982 74.9087 33.7911C74.8224 34.2917 74.5636 34.7504 74.2186 35.1258L61.0213 47.555C60.4606 48.0972 60.2019 48.8897 60.3313 49.6404L63.4365 67.1998C63.6521 68.4928 62.7896 69.7023 61.4526 69.9108C60.9351 69.9943 60.3744 69.9108 59.9 69.6606L43.5974 61.3606C42.9074 60.9852 42.0448 60.9852 41.3547 61.3606L25.0522 69.6606C23.8446 70.2445 22.3782 69.8274 21.7744 68.6596C21.5157 68.2008 21.4294 67.6586 21.5157 67.1581L24.6209 49.5987C24.7503 48.848 24.4915 48.0555 23.9309 47.5133L10.7336 35.1675C9.78472 34.2499 9.7416 32.7484 10.6904 31.8308C11.0786 31.4555 11.553 31.2052 12.0705 31.1635L30.2707 28.6193C31.047 28.4941 31.7371 28.0354 32.0821 27.3263L40.2334 11.3519C40.8372 10.184 42.2604 9.72525 43.468 10.2675C44.0287 10.476 44.4169 10.8514 44.6325 11.3102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0225 67.6626C60.85 67.6626 60.7206 67.6208 60.5481 67.5374L44.2455 59.2374C43.1242 58.6535 41.7441 58.6535 40.6227 59.2374L24.3633 67.5791C24.2339 67.6626 24.0614 67.7043 23.932 67.7043C23.6301 67.7043 23.3713 67.5791 23.1988 67.3706C23.0263 67.162 22.9401 66.8701 22.9832 66.6198L26.0884 49.0605C26.3041 47.8509 25.8728 46.5997 24.9671 45.7238L11.7267 33.2529C11.3385 32.8775 11.3385 32.2936 11.7267 31.9182C11.856 31.7514 12.0717 31.668 12.2873 31.6263L30.5307 29.082C31.7814 28.9152 32.9027 28.1227 33.4634 27.0383L41.6147 11.0639C41.8734 10.6051 42.4341 10.4383 42.9517 10.6885C43.1242 10.7719 43.2536 10.8971 43.3398 11.0639L51.4911 27.0383C52.0518 28.1644 53.1731 28.9152 54.4238 29.082L72.6671 31.6263C73.1847 31.7097 73.5728 32.1685 73.4866 32.669C73.4435 32.8775 73.3572 33.0444 73.1847 33.2112L59.9874 45.6404C59.0817 46.5163 58.6504 47.7675 58.866 48.9771L61.9713 66.5364C62.0144 66.7867 61.9713 67.0786 61.7557 67.2872C61.5831 67.5374 61.3244 67.6626 61.0225 67.6626Z",
    fill: "url(#paint_green_star_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_green_star_d",
    x: 6,
    y: 10,
    width: 72.9988,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_green_star_linear",
    x1: 42.4557,
    y1: 67.6917,
    x2: 42.4557,
    y2: 10.5684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A753"
  })))));
};

export default __webpack_public_path__ + "static/media/green-star.ddd7e98a.svg";
export { SvgGreenStar as ReactComponent };